
import * as d3 from "../lib/d3.js";
import {isNumberArray} from "../framework/validate.js";

/**
 * @param svg D3 selection for the SVG annotation layer
 * @param {string} id unique id for this annotation
 * @param {object|null} feature GeoJSON Feature object, or null to remove
 */
export function annotate(svg, id, feature) {

    const existing = svg.select(`#${id}`);
    if (feature === null) {
        existing.remove();
        return;
    }
    const element = d3.select(existing.node() ?? svg.append("path").attr("id", id).node()).datum(feature);

    const styling = feature.properties;
    const fill = d3.color(styling.fill);
    const stroke = d3.color(styling.stroke);
    const {strokeWidth, strokeDasharray} = styling;

    if (fill) {
        element.attr("fill", fill.copy({opacity: 1}));
        element.attr("fill-opacity", fill.opacity !== 1 ? fill.opacity : null);
    } else {
        element.attr("fill", null);
        element.attr("fill-opacity", 0);
    }

    if (stroke) {
        element.attr("stroke", stroke.copy({opacity: 1}));
        element.attr("stroke-opacity", stroke.opacity !== 1 ? stroke.opacity : null);
        element.attr("stroke-width", strokeWidth ?? 1);
        element.attr("stroke-dasharray", isNumberArray(strokeDasharray) ? strokeDasharray.join(",") : null);
    } else {
        element.attr("stroke", null);
        element.attr("stroke-opacity", null);
        element.attr("stroke-width", null);
        element.attr("stroke-dasharray", null);
    }

    feature.size = styling.pointRadius ?? 5;
}
